import React, { useContext } from 'react'

const ReportingAccessContext = React.createContext(false)

export const ReportingAccessProvider = ReportingAccessContext.Provider

export const useReportingAccess = (): boolean =>
  useContext(ReportingAccessContext)
